import {
    GET_PROMOS,
    PROMO_ERROR,
    ADD_PROMO,
    DELETE_PROMO,
    GET_PROMO,
    UPDATE_PROMO
} from "../../actions/types";

const initalizeState = {
    promos: [],
    loading: true,
    error: {},
    updatedAt: new Date()
};

export default function(state = initalizeState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_PROMOS:
            return {
                ...state,
                promos: payload.promos,
                loading: false,
            };
        case ADD_PROMO:
            return {
                ...state,
                promos: [payload.promo, ...state.promos],
                loading: false,
                updatedAt: new Date(),
            };
        case DELETE_PROMO:
            return {
                ...state,
                promos: state.promos.filter(promo => promo.id !== payload),
                loading: false,
                updatedAt: new Date(),
            };
        case UPDATE_PROMO:
            let promos = state.promos;
            promos = promos.filter(promo => {
                return promo.id !== payload.promo.id;
            });
            return {
                ...state,
                promos: [payload.promo, ...promos],
                loading: false,
                updatedAt: new Date(),
            };
        case GET_PROMO:
            return {
                ...state,
                loading: false
            };
        case PROMO_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
